import AssetOrganization from './AssetOrganization'
export default AssetOrganization
